import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HeaderComponent } from './core/header/header.component';
import { NavbarComponent } from './core/navbar/navbar.component';
import { BookListComponent } from './book/book-list/book-list.component';
import { EditBookComponent } from './book/edit-book/edit-book.component';
import { SearchFormComponent } from './book/search-form/search-form.component';
import { TableComponent } from './book/table/table.component';
import { PaginationComponent } from './book/pagination/pagination.component';

import { AppRoutingModule } from './app-routing/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavbarComponent,
    BookListComponent,
    EditBookComponent,
    SearchFormComponent,
    TableComponent,
    PaginationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
